export default import.meta.ROLLDOWN_FILE_URL_uYD97iiL1i0IH__9K2gHUA